@let feedback = feedbackPromise | async;
@if (feedback) {
  <app-card>
    <div>
      @if (feedback.length) {
        <h1>{{ feedback[0].feature }}</h1>
        <div class="header-info">
          <div>
            <span i18n>Responses:</span> <b>{{ feedback.length }}</b>
          </div>
          @if (rating() >= 0) {
            <div class="rating">
              <span i18n>Score:</span> <b>{{ rating() | number: "1.0-2" }}</b> <app-rating-icon [rating]="rating()" />
            </div>
          }
        </div>
      }
    </div>
    <div class="actions">
      <app-feedback-download [data]="rowData()" [feature]="feature" />
      <app-feedback-filter [colDefs]="colDefs()" (columnUpdate)="updateColumns($event)" />
    </div>
    <ag-grid-angular
      [rowData]="rowData()"
      [columnDefs]="colDefs()"
      [defaultColDef]="defaultColDef"
      [pagination]="true"
      [paginationPageSize]="25"
      [paginationPageSizeSelector]="false"
    />
  </app-card>
}
